import { BUTTON, BUTTON_SETTINGS } from '../elements/link'

export const HERO_ANIMATION = `
...on heroAnimation_Entry {
  id
  typeHandle
  
  heading {
    html
  }
  description
  
  ${ BUTTON }
  ${ BUTTON_SETTINGS }
  
  animatedText {
    html
  }
  
  imagesDesktop {
    url
    title
    width
    height
  }
  
  imagesMobile {
    url
    title
    width
    height
  }
}
`